import { RouteComponentProps, useHistory } from "react-router-dom";
import { PayerRequirementDetails } from "./PayerRequirementDetails";
import { WSPage } from "@wingspanhq/fe-component-library";
import { queriesRequirements } from "@query";
import { WSQueries } from "../../../../../query/WSQuery";
import { Fullscreen } from "../../../../../components/Fullscreen/Fullscreen";
import { useHistoryCheckpoint } from "../../../../../shared/hooks/useHistoryCheckpoint";

export const DASHBOARD_PAYER_REQUIREMENTS_ROOT_PATH =
  "/member/dashboard/payer/:payerId/requirement/:requirementId";

export const useGoToDashboardPayerRequirementDetails = () => {
  const history = useHistory();
  const historyCheckpoint = useHistoryCheckpoint(
    DASHBOARD_PAYER_REQUIREMENTS_ROOT_PATH
  );

  return (params: { payerId: string; requirementId: string }) => {
    historyCheckpoint.saveCheckpoint();

    history.push(
      DASHBOARD_PAYER_REQUIREMENTS_ROOT_PATH.replace(
        ":payerId",
        params.payerId
      ).replace(":requirementId", params.requirementId)
    );
  };
};

/**
 * The `:payerId` segment carries what the notification context calls
 * `payer.payerId` — on v3 that value is the payer's *account* id, not a `Payer`
 * resource id (a v3 `Payer.id` is the composite `<payerAccountId>_<payeeAccountId>`
 * for a linked client, or a standalone id for a platform payer). It therefore
 * cannot be handed to `getPayer`, which 404s on it and used to fail the whole
 * page into the "doesn't exist" state. Nothing on this screen renders the payer
 * anyway — the requirement instance carries its own name and status — so the
 * segment stays purely for deep-link/back-navigation identity and no payer is
 * read here.
 */
export const RoutePayerRequirementDetails: React.FC<
  RouteComponentProps<{
    payerId: string;
    requirementId: string;
  }>
> = ({
  match: {
    params: { requirementId }
  }
}) => {
  const queryRequirement = queriesRequirements.getPayeeRequirement.useQuery({
    requirementId
  });

  return (
    <Fullscreen>
      <WSPage>
        <WSQueries
          queries={{
            queryRequirement
          }}
        >
          {({ queryRequirementData }) => {
            return (
              <PayerRequirementDetails requirement={queryRequirementData} />
            );
          }}
        </WSQueries>
      </WSPage>
    </Fullscreen>
  );
};
